/* ============================================================
   ZENARA THEME — global.js v1.0.0
   Lightweight, dependency-free. Section-specific JS stays in
   its section file; only shared behaviors live here.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Sticky header shadow ---------- */
  var header = document.querySelector('[data-site-header]');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('scrolled', window.scrollY > 10);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Scroll reveal (IntersectionObserver) ---------- */
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = window.Shopify && window.Shopify.designMode;
  var animate = !reduced && !designMode && !document.body.classList.contains('no-reveal') && 'IntersectionObserver' in window;
  var io = animate ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12 }) : null;
  function initReveals(root) {
    (root || document).querySelectorAll('.reveal:not(.in)').forEach(function (el) {
      if (animate) { io.observe(el); } else { el.classList.add('in'); }
    });
  }
  initReveals();
  /* Theme editor re-renders sections via AJAX — re-init so content is never left invisible */
  document.addEventListener('shopify:section:load', function (e) { initReveals(e.target); });

  /* ---------- Drawer toggles (mobile menu, etc.) ----------
     Usage: <button data-drawer-open="id"> / <button data-drawer-close="id">
     Target: <div id="id" class="drawer"> — gets .open toggled          */
  document.addEventListener('click', function (ev) {
    var opener = ev.target.closest('[data-drawer-open]');
    if (opener) {
      var t = document.getElementById(opener.getAttribute('data-drawer-open'));
      if (t) { t.classList.add('open'); t.setAttribute('aria-hidden', 'false'); }
      return;
    }
    var closer = ev.target.closest('[data-drawer-close]');
    if (closer) {
      var c = document.getElementById(closer.getAttribute('data-drawer-close'));
      if (c) { c.classList.remove('open'); c.setAttribute('aria-hidden', 'true'); }
    }
  });

  /* Close drawers on Escape */
  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape') {
      document.querySelectorAll('.drawer.open').forEach(function (d) {
        d.classList.remove('open');
        d.setAttribute('aria-hidden', 'true');
      });
    }
  });

  /* ---------- Rotator (announcement bar) ----------
     Usage: <div data-rotator data-interval="4000"><span>...</span><span>...</span></div> */
  document.querySelectorAll('[data-rotator]').forEach(function (rot) {
    var items = Array.prototype.slice.call(rot.children);
    if (items.length < 2 || reduced) return;
    var i = 0;
    items.forEach(function (el, idx) { el.style.display = idx === 0 ? '' : 'none'; });
    setInterval(function () {
      items[i].style.display = 'none';
      i = (i + 1) % items.length;
      items[i].style.display = '';
      items[i].style.animation = 'none';
      void items[i].offsetWidth; /* restart animation */
      items[i].style.animation = '';
    }, parseInt(rot.getAttribute('data-interval') || '4000', 10));
  });

})();


/* ============================================================
   CART DRAWER — Zenara v1.2.2
   AJAX add-to-cart + slide-out drawer with live line items.
   ============================================================ */
(function () {
  'use strict';

  var drawer = document.getElementById('CartDrawer');
  if (!drawer) return;

  var body = drawer.querySelector('[data-cart-body]');
  var emptyEl = drawer.querySelector('[data-cart-empty]');
  var footEl = drawer.querySelector('[data-cart-foot]');
  var subtotalEl = drawer.querySelector('[data-cart-subtotal]');
  var lastFocus = null;

  function money(cents) {
    var format = window.Shopify && window.Shopify.moneyFormat ? window.Shopify.moneyFormat : 'Rs.{{amount}}';
    var val = (cents / 100).toFixed(2).replace(/\.00$/, '');
    val = val.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format.replace(/\{\{\s*amount[^}]*\}\}/, val);
  }

  function openDrawer() {
    lastFocus = document.activeElement;
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var closeBtn = drawer.querySelector('[data-cart-close]');
    if (closeBtn) closeBtn.focus();
  }
  function closeDrawer() {
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }

  function render(cart) {
    // Update all cart counters on the page
    document.querySelectorAll('[data-cart-count], .cart-count').forEach(function (el) {
      el.textContent = cart.item_count;
      if (el.classList.contains('cart-count')) el.style.display = cart.item_count > 0 ? '' : 'none';
    });
    if (subtotalEl) subtotalEl.textContent = money(cart.total_price);

    if (cart.item_count === 0) {
      body.innerHTML = '';
      body.hidden = true;
      if (emptyEl) emptyEl.hidden = false;
      if (footEl) footEl.hidden = true;
      return;
    }
    body.hidden = false;
    if (emptyEl) emptyEl.hidden = true;
    if (footEl) footEl.hidden = false;

    body.innerHTML = cart.items.map(function (item, i) {
      var variant = (item.product_has_only_default_variant) ? '' :
        '<p class="cd-item__variant">' + item.variant_title + '</p>';
      var img = item.image ? '<img src="' + item.image.replace(/(\.[^.]+)$/, '_160x$1') + '" alt="' + item.product_title + '" width="72">' : '';
      return '' +
        '<div class="cd-item" data-line="' + (i + 1) + '">' +
          '<a href="' + item.url + '" class="cd-item__img" data-cart-close>' + img + '</a>' +
          '<div>' +
            '<a href="' + item.url + '" class="cd-item__title" data-cart-close>' + item.product_title + '</a>' +
            variant +
            '<div class="cd-item__qty">' +
              '<button type="button" data-line-minus="' + (i + 1) + '" aria-label="Decrease">−</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-line-plus="' + (i + 1) + '" aria-label="Increase">+</button>' +
            '</div>' +
          '</div>' +
          '<div class="cd-item__right">' +
            '<span class="cd-item__price">' + money(item.final_line_price) + '</span>' +
            '<button type="button" class="cd-item__remove" data-line-remove="' + (i + 1) + '">Remove</button>' +
          '</div>' +
        '</div>';
    }).join('');
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  function changeLine(line, qty) {
    drawer.classList.add('is-loading');
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); drawer.classList.remove('is-loading'); })
      .catch(function () { drawer.classList.remove('is-loading'); });
  }

  function addToCart(id, qty) {
    drawer.classList.add('is-loading');
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(id, 10), quantity: qty || 1 })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return fetchCart();
    }).then(function (cart) {
      render(cart);
      drawer.classList.remove('is-loading');
      openDrawer();
    }).catch(function () {
      drawer.classList.remove('is-loading');
      alert('Sorry, this item could not be added. Please try again.');
    });
  }

  // Open drawer when clicking the header cart icon (intercept nav to /cart)
  document.querySelectorAll('a[href$="/cart"], a[href*="/cart?"]').forEach(function (link) {
    if (link.closest('[data-cart-body]')) return;
    if (link.hasAttribute('data-no-drawer')) return;
    link.addEventListener('click', function (e) {
      // only intercept the header cart link, not "view cart" inside drawer footer
      if (link.classList.contains('cart-drawer__viewcart') || link.classList.contains('cart-drawer__checkout')) return;
      e.preventDefault();
      fetchCart().then(function (cart) { render(cart); openDrawer(); });
    });
  });

  // Quick-add buttons on product cards
  document.addEventListener('click', function (ev) {
    var qa = ev.target.closest('[data-quick-add]');
    if (qa) {
      ev.preventDefault();
      var id = qa.getAttribute('data-variant-id');
      if (id) addToCart(id, 1);
      return;
    }
    // Close triggers
    if (ev.target.closest('[data-cart-close]')) { closeDrawer(); return; }
    // Line quantity / remove inside drawer
    var minus = ev.target.closest('[data-line-minus]');
    var plus = ev.target.closest('[data-line-plus]');
    var remove = ev.target.closest('[data-line-remove]');
    if (minus || plus || remove) {
      var lineEl = ev.target.closest('.cd-item');
      var line = parseInt(lineEl.getAttribute('data-line'), 10);
      var current = parseInt(lineEl.querySelector('.cd-item__qty span').textContent, 10);
      if (remove) changeLine(line, 0);
      else if (plus) changeLine(line, current + 1);
      else if (minus) changeLine(line, Math.max(0, current - 1));
    }
  });

  // Product-page form: submit via AJAX into drawer
  var pForm = document.getElementById('ProductForm');
  if (pForm) {
    pForm.addEventListener('submit', function (e) {
      // Let "Buy It Now" (checkout) submit normally
      if (e.submitter && e.submitter.name === 'checkout') return;
      e.preventDefault();
      var idField = pForm.querySelector('[name="id"]');
      var qtyField = pForm.querySelector('[name="quantity"]');
      if (idField) addToCart(idField.value, qtyField ? parseInt(qtyField.value, 10) : 1);
    });
  }

  // Escape closes drawer
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('open')) closeDrawer();
  });
})();
